/**
 * Rankings hub reached from the home menu: one row per song, tap to open
 * the world top-20 overlay (with difficulty tabs).
 */
export default class RankingsScreen {
  constructor({ onBack, overlay, getDifficulty }) {
    this.onBack = onBack;
    this.overlay = overlay;
    this.getDifficulty = getDifficulty;
    this.listEl = document.getElementById('rankings-list');

    document.getElementById('btn-rankings-back')?.addEventListener('click', () => this.onBack?.());
  }

  render(songs) {
    if (!this.listEl) return;
    this.listEl.textContent = '';

    for (const song of songs) {
      const row = document.createElement('button');
      row.type = 'button';
      row.className = 'rankings-row';
      row.setAttribute('role', 'listitem');

      const info = document.createElement('span');
      info.className = 'rankings-row__info';

      const title = document.createElement('strong');
      title.className = 'rankings-row__title';
      title.textContent = String(song.title ?? '').slice(0, 48).toUpperCase();

      const artist = document.createElement('span');
      artist.className = 'rankings-row__artist';
      artist.textContent = String(song.artist ?? '').slice(0, 48).toUpperCase();

      info.append(title, artist);

      const cta = document.createElement('span');
      cta.className = 'rankings-row__cta';
      cta.textContent = 'TOP 20 →';

      row.append(info, cta);
      row.addEventListener('click', () => this.overlay.open(song, this.getDifficulty?.() ?? 'normal'));
      this.listEl.appendChild(row);
    }
  }
}
